import authHeaders from 'helpers/auth-header';
import request from './api';

function createUser(parentId, identificationNumber, body) {
  return request({
    url: `/user/parent-id/${parentId}/identification-number/${identificationNumber}`,
    method: 'POST',
    headers: authHeaders(),
    data: { ...body },
  });
}

function updateUser(id, body) {
  return request({
    url: `/user/id/${id}`,
    method: 'PUT',
    headers: authHeaders(),
    data: { ...body },
  });
}

function setUserStatus(id, status) {
  return request({
    url: `/user/id/${id}/set-status/${status}`,
    method: 'DELETE',
    headers: authHeaders(),
  });
}

function getSubUsers(identificationNumber) {
  return request({
    url: `/user/sub-users/identification-number/${identificationNumber}`,
    method: 'GET',
    headers: authHeaders(),
  });
}

function deleteUser(id) {
  return request({
    url: `/user/id/${id}`,
    method: 'DELETE',
    headers: authHeaders(),
  });
}

const user = {
  getSubUsers,
  setUserStatus,
  deleteUser,
  createUser,
  updateUser,
};

export default user;
